import { MdVerified } from 'react-icons/md';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';
import './TeamListStyles.css';

// Import the known teams list
const knownTeams = [
    "EMINENTS WC",
    "Kampala International University (KIU)",
    "NDEJJE CORPORATE WC",
    "MAKERERE UNIVERSITY",
    "KISUBI CORPORATE",
    "UNIVERSITY OF KISUBI",
    "BUGEMA UNIVERSITY",
    "MUBS WC",
    "PRISONS WC",
    "BANK OF UGANDA",
    "DIGEL WC",
    "Uganda National Examinations Board",
    "VISION GROUP",
    "AIRFORCE SS",
    "isaac WC",
    "Islamic University In Uganda",
    "Ministry of Public Service"

];

const TeamList = () => {
    const [teams, setTeams] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const { currentUser } = useAuth();

    // Helper function to check if team is known
    const isKnownTeam = (teamName) => {
        return knownTeams.some(knownTeam => 
            knownTeam.toLowerCase() === teamName.toLowerCase()
        );
    };

    // Helper function to format date
    const formatDate = (dateString) => {
        if (!dateString || dateString === 'Unknown') return 'Unknown';
        try {
            const date = new Date(dateString);
            return new Intl.DateTimeFormat('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            }).format(date);
        } catch (e) {
            return dateString;
        }
    };

    useEffect(() => {
        const fetchTeams = async () => {
            try {
                // Get the current user's auth token
                const token = await currentUser.getIdToken();
                
                // Send the token in the Authorization header
                const response = await axios.get('https://woodball-586444644604.us-central1.run.app/registrations', {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                
                setTeams(response.data);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching teams:', error);
                setError(error.response?.data?.error || 'Unable to load teams. Please try again later.');
                setLoading(false);
            }
        };
        
        fetchTeams();
    }, [currentUser]);

    const approveTeam = async (teamId) => {
        try {
            setLoading(true);
            // Get the current user's auth token
            const token = await currentUser.getIdToken();
            
            // Send the token in the Authorization header
            await axios.put(`https://woodball-586444644604.us-central1.run.app/approve/${teamId}`, {}, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            
            // Refresh the team list instead of just updating in-memory
            const token2 = await currentUser.getIdToken();
            const response = await axios.get('https://woodball-586444644604.us-central1.run.app/registrations', {
                headers: {
                    'Authorization': `Bearer ${token2}`
                }
            });
            setTeams(response.data);
            setLoading(false);
            
        } catch (error) {
            console.error('Error approving team:', error);
            alert(error.response?.data?.error || 'Failed to approve team');
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="teams-container">
                <div className="loading">Loading teams...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="teams-container">
                <div className="error">{error}</div>
            </div>
        );
    }

    return (
        <div className="teams-container">
            <div className="teams-card">
                <h2 className="teams-title">Registered Teams</h2>
                
                {teams.length === 0 ? (
                    <p className="no-teams">No teams registered yet.</p>
                ) : (
                    <div className="teams-list">
                        {teams.map((team) => (
                            <div className="team-item" key={team.id}>
                                <div className="team-header">
                                    <div className="team-name-container">
                                        <h3 className="team-name">{team.teamName}</h3>
                                        {isKnownTeam(team.teamName) && (
                                            <MdVerified title="Verified Team" className="verified-team-icon" />
                                                                                            
                                        )}
                                    </div>
                                    <span className={`team-status status-${team.status.toLowerCase()}`}>
                                        {team.status}
                                    </span>
                                </div>
                                <div className="team-players">
                                    <strong>Players:</strong> {team.players}
                                </div>
                                <div className="team-contact">
                                    <strong>Contact:</strong> {team.contact} ({team.email})
                                </div>
                                <div className="team-registration-info">
                                    <div className="registration-detail">
                                        <strong>Registered by:</strong> {team.registeredBy} ({team.registeredEmail})
                                    </div>
                                    <div className="registration-detail">
                                        <strong>Registration Date:</strong> {formatDate(team.registrationDate)}
                                    </div>
                                    
                                    {team.status === 'Approved' && (
                                        <>
                                            <div className="registration-detail">
                                                <strong>Approved by:</strong> {team.approvedBy || 'N/A'}
                                            </div>
                                            <div className="registration-detail">
                                                <strong>Approval Date:</strong> {formatDate(team.approvalDate)}
                                            </div>
                                        </>
                                    )}
                                </div>
                                
                                {currentUser && currentUser.admin === true && team.status === 'Pending' && (
                                    <button 
                                        className={`approve-btn ${isKnownTeam(team.teamName) ? 'approve-verified' : ''}`}
                                        onClick={() => approveTeam(team.id)}
                                    >
                                        {isKnownTeam(team.teamName) ? 'Approve' : 'Approve Team'}
                                    </button>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default TeamList;